/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_30_SInputs */

const en_funnel_ob_daily_30_s = /** @type {(inputs: Funnel_Ob_Daily_30_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most popular, a paper or a chapter`)
};

const es_funnel_ob_daily_30_s = /** @type {(inputs: Funnel_Ob_Daily_30_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El más elegido: un artículo o un capítulo`)
};

/**
* | output |
* | --- |
* | "Most popular, a paper or a chapter" |
*
* @param {Funnel_Ob_Daily_30_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_30_s = /** @type {((inputs?: Funnel_Ob_Daily_30_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_30_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_30_s(inputs)
	return en_funnel_ob_daily_30_s(inputs)
});